<template>
  <div>
    <vue-snotify></vue-snotify>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"
    ></loading>
    <b-row>
      <b-col lg="2">
        <div>
          <b-button
            block
            variant="outline-primary"
            @click="setActiveTab(1)"
            :class="active_tab == 1 ? 'active' : ''"
          >
            <i class="fa-solid fa-chart-column"></i>
            Claim Upload
            <i class="fa-solid fa-upload"></i>
          </b-button>
          <label class="label label-size text-muted">{{
            claimLastModified
          }}</label>
          <b-button
            block
            variant="outline-primary"
            @click="bosExport()"
            :class="active_tab == 2 ? 'active' : ''"
          >
            <i class="fa-solid fa-file"></i>
            BOS Export
            <i class="fa-solid fa-file-export"></i>
          </b-button>
        </div>
      </b-col>
      <b-col lg="10">
        <div v-if="active_tab == 1">
          <ClaimUpload />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "../Vuetable/VuetablePaginationBootstrap4.vue";
import ClientUpload from "./Uploads/Clients/ClientUpload.vue";
import ClaimUpload from "./Uploads/Claims/ClaimUpload.vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import mixins from "./../../mixins/common.js";
import moment from "moment";

export default {
  components: {
    Vuetable,
    VuetablePagination,
    ClientUpload,
    ClaimUpload,
  },
  mixins: [mixins],
  data() {
    return {
      excel_file: null,
      perPage: 10,
      allClients: [],
      excelData: [],
      fullPage: true,
      isLoading: false,
      excelError: null,
      active_tab: 1,
      claimLastModified: "",
    };
  },
  watch: {
    excelData(newVal, oldVal) {
      this.$refs.vuetableExcel.refresh();
    },
  },
  methods: {
    ...mapActions("admin", [
      "excelFileRead",
      "confirmFileUpload",
      "claimUploadLastModified",
      "bosExportFile",
    ]),
    bosExport() {
      this.isLoading = true;
      this.bosExportFile().then((data) => {
        if (data.data) {
          let blob = data.data;
          const url = URL.createObjectURL(
            new Blob([blob], {
              type: 'text/csv;charset=utf-8;'
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "box_export_" + moment() + ".csv");
          document.body.appendChild(link);
          link.click();
        } else {
        }
        this.isLoading = false;
      });
    },
    refreshLastModified() {
      this.claimUploadLastModified().then((data) => {
        if (data.data && data.data.data) {
          this.claimLastModified = data.data.data.claimCreatedString;
        }
      });
    },
    setActiveTab(tab) {
      this.active_tab = tab;
    },
    confirmAction() {
      this.isLoading = true;
      this.confirmFileUpload().then((data) => {
        if (data.data.success && data.data.success.status) {
          this.excelError = null;
          this.excelData = [];
        }
        this.isLoading = false;
      });
    },
    uploadExcelFile() {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("file", this.excel_file);

      this.excelFileRead(formData).then((data) => {
        if (data.data.error.status == "false") {
          this.excelError = 0;
        } else {
          this.excelError = 1;
        }
        if (data.data.data) {
          this.excelData = _.values(data.data.data);
          this.$bvModal.hide("bv-modal-example-2");
        } else {
        }
        this.isLoading = false;
      });
    },
    onPaginationDataAllClients(paginationData) {
      this.$refs.pagination_allclients.setPaginationData(paginationData);
    },
    onChangePageAllClients(page) {
      this.$refs.vuetableAllClients.changePage(page);
    },
    dataManagerAllClients(sortOrder, pagination) {
      let local = [];

      local = this.allClients;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetableAllClients.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },

    onPaginationDataExcel(paginationData) {
      this.$refs.pagination_excel.setPaginationData(paginationData);
    },
    onChangePageExcel(page) {
      this.$refs.vuetableExcel.changePage(page);
    },
    dataManagerExcel(sortOrder, pagination) {
      let local = [];

      local = this.excelData;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetableExcel.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
  },
  computed: {
    activeClaim: {
      get() {
        return this.$store.state.activeClaim;
      },
      set(val) {
        this.$store.state.activeClaim = val;
      },
    },
  },
  mounted() {
    this.refreshLastModified();
    //clear snotofy
    this.clearSnotifyMessages();
  },
};
</script>

<style scoped>
.label-size {
  font-size: 0.7rem;
  font-weight: 300;
  line-height: 1.7;
}

.color-block {
  margin-left: 2px;
  margin-right: 2px;
  margin-top: 5px;
  float: right;
  min-height: 12px;
  min-width: 12px;
  max-height: 12px;
  max-width: 12px;
}
</style>
